import { render } from "./RiTutorial03.vue?vue&type=template&id=cf0c2e24"
import script from "./RiTutorial03.vue?vue&type=script&lang=js"
export * from "./RiTutorial03.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiTutorial03.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cf0c2e24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cf0c2e24', __exports__)) {
    api.reload('cf0c2e24', __exports__)
  }
  
  module.hot.accept("./RiTutorial03.vue?vue&type=template&id=cf0c2e24", () => {
    api.rerender('cf0c2e24', render)
  })

}


export default __exports__